// spec-49 §7.4 — the initial SelectedProjectFileIds of a new re-delivery order. A pre-selection (the
// versions library starting from one version) wins when at least one of its ids is offered; otherwise the
// single-version case is auto-selected (no choice to make) and anything else starts empty — the
// version-selection page is where the user chooses. CreateOrder re-validates against the offered set anyway.
export const initialSelectedFileIds = (
  preselected: number[] | undefined,
  offered: { ProjectFileId: number }[]
): number[] => {
  const offeredIds = offered.map((v) => v.ProjectFileId);
  const kept = (preselected || []).filter((id) => offeredIds.includes(id));
  if (kept.length) return kept;
  return offeredIds.length === 1 ? [offeredIds[0]] : [];
};
